const _temp0 = require("./Puna.png");
const _temp1 = require("./Puna_1.png");
const _temp2 = require("./Puna_2.png");
const _temp3 = require("./Puna_3.png");
const _temp4 = require("./Puna_4.png");
const _temp5 = require("./Puna_5.png");
const _temp6 = require("./Sini.png");
const _temp7 = require("./Sini_1.png");
const _temp8 = require("./Sini_2.png");
const _temp9 = require("./Sini_3.png");
const _temp10 = require("./Sini_4.png");
const _temp11 = require("./Sini_5.png");
const _temp12 = require("./Valko.png");
const _temp13 = require("./Valko_1.png");
const _temp14 = require("./Valko_2.png");
const _temp15 = require("./Valko_3.png");
const _temp16 = require("./Valko_4.png");
const _temp17 = require("./Valko_5.png");
module.exports = {
  "Puna": _temp0,
  "Puna_1": _temp1,
  "Puna_2": _temp2,
  "Puna_3": _temp3,
  "Puna_4": _temp4,
  "Puna_5": _temp5,
  "Sini": _temp6,
  "Sini_1": _temp7,
  "Sini_2": _temp8,
  "Sini_3": _temp9,
  "Sini_4": _temp10,
  "Sini_5": _temp11,
  "Valko": _temp12,
  "Valko_1": _temp13,
  "Valko_2": _temp14,
  "Valko_3": _temp15,
  "Valko_4": _temp16,
  "Valko_5": _temp17
}